import axios from 'axios'

export const putContactAddress = async (contactAddress: any) => {
  return await axios.put(
    `${process.env.REACT_APP_API_URL}/contactAddress/${contactAddress.id}`,
    contactAddress,
    {
      withCredentials: true,
    },
  )
}
